// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules_dev/css-loader/dist/cjs.js??ref--3-oneOf-1-1!../../node_modules_dev/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules_dev/postcss-loader/src/index.js??ref--3-oneOf-1-2!../../node_modules_dev/vue-loader/lib/index.js??vue-loader-options!./nuxt-loading.vue?vue&type=style&index=0&lang=css&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules_dev/vue-style-loader/lib/addStylesClient.js").default
var update = add("782b1799", content, true, {"sourceMap":false});